import { render, staticRenderFns } from "./_base-page-title.vue?vue&type=template&id=c7e878fc"
import script from "./_base-page-title.vue?vue&type=script&lang=js"
export * from "./_base-page-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports